export default __webpack_public_path__ + "static/media/weblogoBlueNew.57da135d.svg";